import React, { useMemo } from 'react';

import { useFiltersStateManager } from './FiltersStateManager';
import ApplyButton from './components/ApplyButton';
import { useFiltersRequiredManager } from './FiltersRequiredManager/useFiltersRequiredManager';

const ApplyFiltersButton = ({ onClick, disabled }) => {
  const { onApplyFilters, dirty, getFilterValue, getFilterValues } =
    useFiltersStateManager();
  const { requiredState } = useFiltersRequiredManager();

  const values = getFilterValues();

  const handleClick = () => {
    onApplyFilters();
    onClick?.();
  };

  const disabledByRequired = useMemo(() => {
    if (!requiredState) {
      return false;
    }
    const keys = Object.keys(requiredState);

    const isValid = keys.every((path) => {
      const value = getFilterValue(path);
      return value?.length > 0;
    });
    return !isValid;
  }, [requiredState, values]);

  return (
    <ApplyButton
      onClick={handleClick}
      disabled={disabled || disabledByRequired || !dirty}
    />
  );
};

export default ApplyFiltersButton;
